<section class="title-row">
  <h2
    class="typography-sub-heading"
    [translate]="'SpecialFormComponent:EditSpecialOccasion'"
    *ngIf="!newSpecialOccasion"
  >
    Edit special occasion
  </h2>
  <h2 class="typography-sub-heading" [translate]="'SpecialFormComponent:AddSpecialOccasion'" *ngIf="newSpecialOccasion">
    Add special occasion
  </h2>
</section>

<form class="push-md-1" novalidate autocomplete="off" [formGroup]="specialOccasionForm">
  <!-- contact type -->
  <div class="row">
    <div class="col-12 pb-0">
      <mat-form-field class="form-input__container">
        <mat-select [placeholder]="'SpecialFormComponent:SpecialTypeLabel' | translate" formControlName="type">
          <mat-option [value]="'anniversary'"
            ><span [translate]="'SpecialFormComponent:Anniversary'">Anniversary</span>
          </mat-option>
          <mat-option [value]="'birthday'"
            ><span [translate]="'SpecialFormComponent:Birthday'">Birthday</span>
          </mat-option>
          <mat-option [value]="'one_off'"
            ><span [translate]="'SpecialFormComponent:One_off'">One off occasion</span>
          </mat-option>
          <mat-option [value]="'yearly_recurring'">
            <span [translate]="'SpecialFormComponent:Yearly_recurring'">Yearly recurring occasion</span>
          </mat-option>
        </mat-select>

        <mat-error
          [translate]="'SpecialFormComponent:SpecialTypeLabelErrorMsg'"
          ngxErrors="type"
          ngxError="required"
          when="touched"
          role="alert"
        >
          Please select a Special Occasion type
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- occasion name -->
  <div class="row">
    <div class="col-12 pb-0">
      <mat-form-field class="form-input__container">
        <input
          matInput
          autocomplete="off"
          name="whatever"
          [placeholder]="'SpecialFormComponent:SpecialOccassion' | translate"
          formControlName="occasion_name"
        />
        <mat-error
          [translate]="'SpecialFormComponent:SpecialOccassionErrorMsg'"
          ngxErrors="occasion_name"
          ngxError="required"
          when="touched"
          role="alert"
        >
          Please provide a Special Occasion name
        </mat-error>
        <mat-error
          [translate]="'TravellerFormComponent:FormAZErrorMsg'"
          ngxErrors="occasion_name"
          ngxError="pattern"
          when="touched"
          role="alert"
        >
          Please only use a-z, hyphens, apostrophes and spaces.
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <!-- date selection -->
  <div class="row">
    <div class="col-12 pb-0" (keyup.escape)="$event.stopPropagation()">
      <mat-form-field class="form-input__container">
        <input
          readonly
          matInput
          autocomplete="off"
          name="whatever"
          [matDatepicker]="dp"
          (click)="dp.open()"
          (keyup.enter)="dp.open()"
          (keyup.space)="dp.open()"
          formControlName="date"
          [placeholder]="'SpecialFormComponent:Date' | translate"
        />
        <mat-datepicker-toggle matSuffix [for]="dp"> </mat-datepicker-toggle>
        <mat-datepicker
          startView="multi-year"
          [touchUi]="innerWidth < 640"
          #dp
          (keyup.escape)="$event.stopPropagation()"
        >
        </mat-datepicker>

        <mat-error
          [translate]="'SpecialFormComponent:DateErrorMsg'"
          ngxErrors="date"
          ngxError="required"
          when="touched"
          role="alert"
        >
          Please select a date for the Special Occasion
        </mat-error>
      </mat-form-field>
    </div>
  </div>
</form>

<section class="submit-row">
  <button
    id="delete-current-record"
    *ngIf="!newSpecialOccasion"
    aria-label="close"
    (click)="removeSpecialOccasion()"
    mat-raised-button
    class="mr-2 remove-button"
  >
    {{ 'ProfileDetails:Delete' | translate }}
  </button>
  <div class="action-buttons" [ngClass]="{ 'action-buttons--has-seperator': !newSpecialOccasion }">
    <button
      id="cancel-current-occasion-edit"
      aria-label="close"
      (click)="closeForm()"
      mat-raised-button
      class="close-button"
    >
      {{ 'PopupForm:Close' | translate }}
    </button>
    <button
      id="save-current-occasion-edit"
      aria-label="submit"
      (click)="submitForm()"
      mat-raised-button
      color="primary"
    >
      {{ 'PopupForm:Submit' | translate }}
    </button>
  </div>
</section>
